import React, { Component, ReactNode } from 'react';

/* eslint-disable react/prop-types */
interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    // Here you could log to an error reporting service
    // e.g., Sentry, LogRocket, etc.
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>{`Something went wrong`}</h2>
            <p>{`We're sorry, but something unexpected happened.`}</p>
            {this.state.error && (
              <details style={{ marginTop: '10px' }}>
                <summary>{`Error details`}</summary>
                <pre style={{ textAlign: 'left', marginTop: '10px' }}>
                  {this.state.error.toString()}
                </pre>
              </details>
            )}
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              style={{ marginTop: '10px', padding: '8px 16px' }}
            >
              {`Reload Page`}
            </button>
          </div>
        )
      );
    }

    return this.props.children;
  }
}
